import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { ToolTip } from 'components/shared';

import styles from './FinishEditingSectionButtonTooltip.module.css';

type FinishEditingSectionButtonTooltipProps = {
   children: ReactNode;
   isVisible: boolean;
};

const FinishEditingSectionButtonTooltip = ({
   children,
   isVisible,
}: FinishEditingSectionButtonTooltipProps) => {
   const { t } = useTranslation();

   return (
      <ToolTip
         content={t('finishEditingSectionTooltip')}
         variant="top"
         classNames={{ wrapper: styles.tooltip }}
         visible={isVisible}
      >
         {children}
      </ToolTip>
   );
};

export default FinishEditingSectionButtonTooltip;
